// src/contexts/AusbildungContext.js
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const AusbildungContext = createContext();

export const AusbildungProvider = ({ children }) => {
  const [ausbildungen, setAusbildungen] = useState([]);
  const [loadingAusbildungen, setLoadingAusbildungen] = useState(true);
  const [errorAusbildungen, setErrorAusbildungen] = useState(null);

  const [ausbildungenKlassen, setAusbildungenKlassen] = useState([]);
  const [loadingAusbildungenKlassen, setLoadingAusbildungenKlassen] = useState(true);
  const [errorAusbildungenKlassen, setErrorAusbildungenKlassen] = useState(null);

  const [ausbildungenPreise, setAusbildungenPreise] = useState([]);
  const [loadingAusbildungenPreise, setLoadingAusbildungenPreise] = useState(true);
  const [errorAusbildungenPreise, setErrorAusbildungenPreise] = useState(null);

  const AUSBILDUNGEN_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Ausbildungen?fields=*.*.*&limit=1500&sort=sort';
  const AUSBILDUNGEN_KLASSEN_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Ausbildungen_Klassen?fields=*&limit=1500';
  const AUSBILDUNGEN_PREISE_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Ausbildungen_Preise?fields=*&limit=1500';

  useEffect(() => {
    const ac = new AbortController();

    const fetchAusbildungen = async () => {
      setLoadingAusbildungen(true); setErrorAusbildungen(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(AUSBILDUNGEN_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setAusbildungen(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorAusbildungen('Ошибка при загрузке Ausbildung');
      } finally {
        if (!ac.signal.aborted) setLoadingAusbildungen(false);
      }
    };

    const fetchAusbildungenKlassen = async () => {
      setLoadingAusbildungenKlassen(true); setErrorAusbildungenKlassen(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(AUSBILDUNGEN_KLASSEN_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setAusbildungenKlassen(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorAusbildungenKlassen('Ошибка при загрузке связей Ausbildung_Klassen');
      } finally {
        if (!ac.signal.aborted) setLoadingAusbildungenKlassen(false);
      }
    };

    const fetchAusbildungenPreise = async () => {
      setLoadingAusbildungenPreise(true); setErrorAusbildungenPreise(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(AUSBILDUNGEN_PREISE_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setAusbildungenPreise(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorAusbildungenPreise('Ошибка при загрузке данных Ausbildungen_Preise');
      } finally {
        if (!ac.signal.aborted) setLoadingAusbildungenPreise(false);
      }
    };

    fetchAusbildungen();
    fetchAusbildungenKlassen();
    fetchAusbildungenPreise();

    /* return () => ac.abort(); */
  }, []);

  return (
    <AusbildungContext.Provider value={{
      ausbildungen,
      loadingAusbildungen,
      errorAusbildungen,

      ausbildungenKlassen,
      loadingAusbildungenKlassen,
      errorAusbildungenKlassen,

      ausbildungenPreise,
      loadingAusbildungenPreise,
      errorAusbildungenPreise,
    }}>
      {children}
    </AusbildungContext.Provider>
  );
};

